import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {useSourcingVehicleDetailQuery} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

import {AdvanceVehicleView} from '../../../../../../../components/AdvanceVehicleView/AdvanceVehicleView';
import {useSourcingCurrency} from '../../../../../../../hooks/useSourcingCurrency';
import {useSourcingTargetCountry} from '../../../../../../../hooks/useSourcingTargetCountry';

interface SourcingVehicleCardProps extends TestIdProps {
  externalId: string;
}

export const SourcingVehicleCard = (props: SourcingVehicleCardProps) => {
  const currency = useSourcingCurrency()?.code;
  const country = useSourcingTargetCountry()?.code;
  const {
    data: vehicle,
    isFetching,
    isError,
  } = useSourcingVehicleDetailQuery(
    isNotNil(props.externalId)
      ? {externalId: props.externalId, currency, buyerCountry: country}
      : skipToken
  );

  return (
    <Box
      borderRadius="medium"
      boxShadow="elevation_1"
      backgroundColor="palettes.white.10.100"
      data-testid={suffixTestId('selectedVehicle-advancedVehicleView', props)}
    >
      <DataStatus isLoading={isFetching} isError={isError} minHeight={50}>
        <AdvanceVehicleView
          vehicle={vehicle}
          data-testid={suffixTestId(
            `selectedVehicle-advancedVehicleView[${props.externalId}]`,
            props
          )}
        />
      </DataStatus>
    </Box>
  );
};
